// extracted by mini-css-extract-plugin
export var cardWrapper = "FoodCard-module--cardWrapper--2mJgw";